import { useI18n } from '@i18n/useI18n';
import {
  Container,
  Content,
  Info,
  Item,
  Percentage,
  StudentImage,
  StudentInfo,
  StudentListTop,
  StudentOptions,
} from './CourseStudentList.styled';
import { useEffect, useState } from 'react';
import { CardTitle, GridCard, SysMsg } from '@components/GridCards/Common.styled';
import StudentThumbnail from '@components/StudentThumbnail';
import { useStore } from '@store/appStore';
import { bgColor } from '@models/RegistrationColors';
import SortOptions from '@components/GridCards/SortOptions';
import { breakpoints } from '@styles/tokens';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import fixedNumber from '@utils/fixedNumber';
import NoteIcon from '@assets/svg/note.svg';
import { OptionButton, TooltipStudentOptions } from '@components/GridCards/StudentList/StudentList.styled';
import PinIcon from '@assets/svg/pin.svg';
import db from '@utils/db';
import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import { AttendanceColors, calculatePercentage, ShowabsenceOrAttendance } from '@utils/percentageTools';

interface IProps {
  title: string;
  content: any;
  scroll?: boolean;
  background?: string;
  titleColor?: string;
  extraButtons?: boolean;
  teacher?: boolean;
  click?: (id, name, studentId?) => any;
  pinnedStudents?: any;
  pinStudent?: (id, pin) => any;
  schoolLeader?: boolean;
}

export const CourseStudentList = (props: IProps) => {
  const {
    callNameSetting,
    settings,
    setAdminSelection,
    adminSelection,
    setCourseAdminSelection,
    courseAdminSelection,
    setSelectedStudent,
    setNote,
    setStudentName,
    client,
    setNoteUserId,
    systemSettings,
  } = useStore();
  const [toggle, setToggle] = useState(false);
  const [items, setItems] = useState([]);
  const [scroll, setScroll] = useState(true);
  const i18n = useI18n();
  const [sort, setSort] = useState('A-Z');
  const [mobile, setMobile] = useState(false);
  const [count, setCount] = useState(10);
  const router = useRouter();
  let allowNotes = systemSettings.find((t) => t.APP_Setting_ID === 9);
  useEffect(() => {
    setItems(props.content);
  }, [props.content]);

  useEffect(() => {
    if (window.innerWidth <= breakpoints.mobile) {
      setMobile(true);
    }
  }, []);

  const handleBackground = (percentage: number) => {
    return AttendanceColors(settings.COLORSETTINGS, percentage)
  };

  let tempItems = [];
  if (items) {
    tempItems = [...items];
    tempItems = tempItems?.sort((a, b) => {
      if (sort === 'A-Z') {
        if (a.firstname < b.firstname) return -1;
        else if (a.firstname === b.firstname) return 0;
        else if (a.firstname > b.firstname) return 1;
      } else if (sort === 'Z-A') {
        if (a.firstname < b.firstname) return 1;
        else if (a.firstname === b.firstname) return 0;
        else if (a.firstname > b.firstname) return -1;
      } else if (sort === '%') {
        if (a.absenceminutepercentage < b.absenceminutepercentage) return 1;
        else if (a.absenceminutepercentage === b.absenceminutepercentage) return 0;
        else if (a.absenceminutepercentage > b.absenceminutepercentage) return -1;
      }
    });
  }

  const click = (displayname, username, name?, id?) => {
    if (props.teacher || props.schoolLeader) {
      props.click(username, name, id);
    } else {
      if (adminSelection.type && adminSelection.type === 'COURSE')
        setCourseAdminSelection(adminSelection.name, adminSelection.val, adminSelection.type, adminSelection.id);
      setAdminSelection(displayname, username, 'STUDENT', id);
    }
  };

  const HandleNote = (e: any, student: any) => {
    e.stopPropagation();
    setStudentName(student.firstname + ' ' + student.lastname);
    setSelectedStudent(student.firstname, student.student_sis_id, false);
    setNoteUserId(student.student_sis_id);
    setNote(true);
  };

  async function togglePin(e: any, item: any, pin: any) {
    e.stopPropagation();
    props.pinStudent(item.student_sis_id, pin);
  }

  const NoteCount = styled.div<{ swipeView?: boolean; fullDayView?: boolean }>`
    position: absolute;
    top: -4px;
    right: -4px;
    width: 20px;
    height: 20px !important;
    background: red;
    color: #fff;
    font-size: 12px;
    border-radius: 30px;
    display: flex;
    align-items: center !important;
    justify-content: center !important;
  `;

  return (
    <GridCard col={2} heightAuto={true} background={props.background} scroll={props.scroll ? items?.length > 5 : false}>
      <Content>
        <StudentListTop scroll={props.scroll ? items?.length > 5 : false}>
          <CardTitle titleColor={props.titleColor}>{props.title}</CardTitle>
          <SortOptions setSort={setSort} />
        </StudentListTop>

        <Container scroll={props.scroll ? items?.length > 5 : false}>
          {items?.length > 0 ? (
            tempItems?.slice(0, mobile ? count : items.length).map((item, i) => (
              <Item
                key={'registration_' + i}
                onClick={() =>
                  click(
                    item.username + ' - ' + item.firstname + ' ' + item.lastname,
                    item.username,
                    item.firstname + ' ' + item.lastname,
                    item.student_sis_id,
                  )
                }
              >
                <Info>
                  <StudentImage>
                    <StudentThumbnail font='3em' name={item.firstname + ' ' + item.lastname} src={item.username} />
                  </StudentImage>
                  <StudentInfo>
                    <span>{item.firstname + ' ' + item.lastname}</span>
                  </StudentInfo>
                  <StudentOptions>
                    {router.pathname !== '/teacherpage' ? (
                      <TooltipStudentOptions
                        content={
                          props.pinnedStudents?.some((a) => a.username === item.username)
                            ? i18n.t(callNameSetting + '-unpin')
                            : i18n.t(callNameSetting + '-pin')
                        }
                        placement={'top-center'}
                        offsetY={10}
                      >
                        <OptionButton
                          active={props.pinnedStudents?.some((a) => a.username === item.username)}
                          display={props.extraButtons}
                          onClick={(e) =>
                            togglePin(
                              e,
                              item,
                              props.pinnedStudents?.some((a) => a.username === item.username),
                            )
                          }
                        >
                          <PinIcon />
                        </OptionButton>
                      </TooltipStudentOptions>
                    ) : (
                      <></>
                    )}
                    {allowNotes && allowNotes.value.toLowerCase() === 'true' ? (
                      <TooltipStudentOptions
                        content={i18n.t(item.notePresent ? callNameSetting + '-tooltip-note' : callNameSetting + '-note')}
                        placement={'top-center'}
                        offsetY={10}
                      >
                        <OptionButton
                          active={item.notePresent && item.notePresent}
                          display={props.extraButtons}
                          onClick={(e) => HandleNote(e, item)}
                        >
                          <NoteIcon />
                          {item.noteUnreadCount > 0 && <NoteCount>{item.noteUnreadCount}</NoteCount>}
                        </OptionButton>
                      </TooltipStudentOptions>
                    ) : (
                      <></>
                    )}
                  </StudentOptions>
                </Info>
                <Percentage backgroundType={bgColor[handleBackground(item.merit?calculatePercentage(item.totallength, item.absenceduration):item.absenceminutepercentage)]}>
                  <span>
                    <b>{ShowabsenceOrAttendance(settings.SHOWPRESENCE, fixedNumber(item.merit?calculatePercentage(item.totallength, item.absenceduration):item.absenceminutepercentage))}%</b>
                  </span>
                </Percentage>
              </Item>
            ))
          ) : items === null ? (
            <RainbowLoader />
          ) : (
            <SysMsg>{i18n.t(callNameSetting + '-no-students-error')}</SysMsg>
          )}
          <>{mobile && count < items?.length - 1 && <button onClick={() => setCount(count + 10)}>{i18n.t('see_more')}</button>}</>
        </Container>
      </Content>
    </GridCard>
  );
};

export default CourseStudentList;
